module.exports = __webpack_public_path__ + "img/icon-home.547c115a.svg";